<template>
  <div :class="['app flex-row align-items-center login-page-container', { 'login-dark': isDark }]">
    
    <!-- Background Animated Shapes for Premium Feel (Visible on Mobile & Desktop) -->
    <div class="login-bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <div class="container z-index-1">
      <b-row class="justify-content-center">
        <b-col md="10" lg="8" xl="8">
          <b-card-group class="login-card-group shadow-lg">
            
            <!-- Left Side: Login Form -->
            <b-card no-body class="p-4 login-form-card position-relative">
              <b-card-body>
                <div class="text-center mb-4 position-relative">
                  <!-- Moon Icon for Dark Mode Toggle -->
                  <div class="position-absolute" style="top: -10px; right: -10px; z-index: 10;">
                    <b-button variant="link" class="text-muted p-2 shadow-none" @click="toggleTheme()" title="Alternar Tema">
                      <i class="fa fa-moon-o hover-scale" :class="isDark ? 'text-white' : 'text-secondary'" style="font-size: 1.5rem; transition: transform 0.2s ease, color 0.2s ease;"></i>
                    </b-button>
                  </div>
                  
                  <!-- Attempting to use existing logo asset based on workspace structure -->
                  <img src="static/img/logo-symbol.png" alt="Logo" class="login-logo mb-2" style="max-height: 50px;">
                  <h2 class="font-weight-bold text-dark mt-2 mb-0">Feitosa Filial</h2>
                  <h5 class="font-weight-bold text-primary mb-2">CECFrigo</h5>
                  <p class="text-muted small">Bem-vindo! Informe suas credenciais.</p>
                </div>

                <form @submit.stop.prevent="login">
                  <div class="custom-input-group mb-3">
                    <span class="input-icon"><i class="icon-user"></i></span>
                    <input type="text" ref="edLogin" class="form-control custom-input" placeholder="Usuário" v-model="credentials.login">
                  </div>

                  <div class="custom-input-group mb-4">
                    <span class="input-icon"><i class="icon-lock"></i></span>
                    <input type="password" class="form-control custom-input" placeholder="Senha" v-model="credentials.senha">
                  </div>

                  <b-row>
                    <b-col cols="12">
                      <vue-button-spinner
                        type="submit"
                        class="btn-block btn-login"
                        :classDefault="'btn-primary'"
                        :isLoading="isLoading"
                        :disabled="isLoading"
                        :status="status">
                        Acessar Sistema
                      </vue-button-spinner>
                    </b-col>                   
                  </b-row>
                </form>
              </b-card-body>
            </b-card>

            <!-- Right Side: Branding/Info -->
            <b-card no-body class="text-white bg-primary-gradient py-5 d-md-down-none login-info-card overflow-hidden position-relative" style="width:44%">
              
              <!-- Abstract Commercial Graphics Background -->
              <div class="login-graphics-bg">
                
                <!-- Floating Bar Chart Card -->
                <div class="graphic-card card-1">
                  <div class="graphic-header"></div>
                  <div class="graphic-bar-container">
                    <div class="graphic-bar"></div>
                    <div class="graphic-bar"></div>
                    <div class="graphic-bar"></div>
                    <div class="graphic-bar"></div>
                  </div>
                </div>
                
                <!-- Floating Doughnut/Stats Card -->
                <div class="graphic-card card-2">
                  <div class="graphic-circle-wrap">
                    <div class="graphic-circle"></div>
                    <div class="graphic-lines">
                      <div class="g-line w-75"></div>
                      <div class="g-line w-50"></div>
                    </div>
                  </div>
                </div>

                <!-- Floating Trend Card -->
                <div class="graphic-card card-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="g-line w-50 m-0"></div>
                    <span class="badge badge-success bg-success text-white" style="font-size: 0.55rem; padding: 3px 5px;">+24%</span>
                  </div>
                  <svg viewBox="0 0 100 30" class="mini-chart">
                    <polyline points="0,25 20,20 40,22 60,10 80,15 100,2" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></polyline>
                  </svg>
                </div>

                <!-- Bottom Trend Area -->
                <div class="graphic-trend">
                  <svg viewBox="0 0 100 40" preserveAspectRatio="none">
                    <path d="M0,40 L0,30 L20,25 L40,35 L60,15 L80,20 L100,5 L100,40 Z" fill="rgba(255,255,255,0.05)"></path>
                    <polyline points="0,30 20,25 40,35 60,15 80,20 100,5" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="1"></polyline>
                  </svg>
                </div>
              </div>

              <!-- Content with Glassmorphism -->
              <b-card-body class="text-center d-flex align-items-center justify-content-center flex-column z-index-1">
                <div class="glass-content-box">
                  <h2 class="display-5 font-weight-bold mb-3">Hayhu</h2>
                  <p class="lead" style="font-size: 1.1rem; opacity: 0.9;">Produtora & Desenvolvedora de Software.</p>
                  <hr class="border-white opacity-2" style="width: 50px; margin: 20px auto; opacity: 0.4;">
                  <p class="mb-0" style="opacity: 0.8;">Todo o controle e planejamento do seu negócio você faz aqui</p>
                  <p class="small mt-4 mb-0" style="opacity: 0.6;">Versão 5.0.1</p>
                </div>
              </b-card-body>
            </b-card>

          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'

const LOGIN_SEM_ACESSO_MSG = 'Usuário sem vendedor ou funcionário associado. Procure o administrador do sistema.'

const isIdValido = (valor) => {
  if (valor === null || typeof valor === 'undefined') return false
  const normalizado = String(valor).trim()
  if (normalizado === '') return false
  const numerico = Number(normalizado)
  return Number.isFinite(numerico) && numerico > 0
}

export default {
  name: 'Login',
  data () {
    return {
      credentials: {
        login: '',
        senha: ''
      },
      isLoading: false,
      status: '',
      isBusy: false,
      temaCorrente: 'L'
    }
  },
  components: {
    VueButtonSpinner
  },
  computed: {
    foto () {
      return window.localStorage.getItem('foto')
    },
    isDark() {
      return this.temaCorrente === 'D'
    }
  },
  watch: {
    isDark(newVal) {
      this.syncTheme(newVal)
    }
  },
  mounted() {
    // Forçar modo claro na tela de login por padrão
    this.temaCorrente = 'L'
    window.localStorage.setItem('tema', 'L')
    
    // Sync the global body class
    this.syncTheme(false)
    
    // Garante o foco no input de login após renderização
    setTimeout(() => {
      if (this.$refs.edLogin) {
        this.$refs.edLogin.focus()
      }
    }, 500)
  },
  methods: {
    syncTheme(isDark) {
      if (isDark) {
        document.body.classList.add('theme-dark')
      } else {
        document.body.classList.remove('theme-dark')
      }
    },
    toggleTheme() {
      this.temaCorrente = this.temaCorrente === 'D' ? 'L' : 'D'
      window.localStorage.setItem('tema', this.temaCorrente)
    },
    limparSessaoLocal () {
      ;[
        'token',
        'tokenRefresh',
        'foto',
        'nomeusuario',
        'nomeempresa',
        'login',
        'vendedorId',
        'funcionarioId',
        'usuarioId',
        'minimizarMenuWeb',
        'tema'
      ].forEach(chave => window.localStorage.removeItem(chave))
    },
    exibirMensagemLogin (mensagem) {
      this.$root.$bvToast.toast(mensagem, {
        title: 'Aviso',
        autoHideDelay: 2000,
        variant: 'warning',
        appendToast: true
      })
    },
    login () {
      this.isLoading = true
      this.isBusy = true
      this.$http.post('sessions/criardesktopUC', { login: this.credentials.login, senha: this.credentials.senha })
        .then(response => {
          const temVendedor = isIdValido(response.data?.vendedorId)
          const temFuncionario = isIdValido(response.data?.funcionarioId)
          if (!temVendedor && !temFuncionario) {
            this.limparSessaoLocal()
            throw new Error(LOGIN_SEM_ACESSO_MSG)
          }

          window.localStorage.setItem('token', response.data.token)
          window.localStorage.setItem('tokenRefresh', response.data.tokenRefresh)
          window.localStorage.setItem('foto', response.data.foto)
          window.localStorage.setItem('nomeusuario', response.data.nomeusuario)
          window.localStorage.setItem('nomeempresa', response.data.nomeempresa)
          window.localStorage.setItem('login', response.data.login)
          window.localStorage.setItem('vendedorId', response.data.vendedorId)
          window.localStorage.setItem('funcionarioId', response.data.funcionarioId)
          window.localStorage.setItem('usuarioId', response.data.usuarioId)
          window.localStorage.setItem('minimizarMenuWeb', response.data.minimizarMenuWeb)
          // Keep the currently selected theme
          window.localStorage.setItem('tema', this.temaCorrente)
          this.$store.commit('tema/SET_IS_DARK', this.temaCorrente === 'D')
          this.setarFotoUsuario(response.data.foto)

          return this.$store.dispatch('menu/GERAR_LISTA')
        })
        .then(() =>{
          let menus = this.$store.getters['menu/LISTA'] 
          if (menus) {
            document.body.classList.toggle('sidebar-minimized')
            this.$router.replace('/')
            this.isBusy = false
            this.isLoading = false
            this.status = true
          }
        })
        .catch((error) => {
          const mensagem = error?.response?.data?.erro || error?.response?.data || error?.message || 'Usuário ou senha inválidos!!!'
          if (mensagem === LOGIN_SEM_ACESSO_MSG) {
            this.limparSessaoLocal()
          }
          this.exibirMensagemLogin(mensagem)
          this.items = []
          this.isBusy = false
          this.isLoading = false
          this.status = false
        })
    },
    setarFotoUsuario (foto) {
     // this.$store.commit('SETAR_FOTO_USUARIO', foto)
    }
  }
}
</script>

<style scoped>
/* Modern Gradient Background */
.login-page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #e9eff5 0%, #cfdef3 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  transition: background 0.3s ease;
}

/* Card Styling */
.login-card-group {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
}

.login-form-card {
  border: none;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: background-color 0.3s ease;
}

/* Background Animated Shapes */
.login-bg-shapes {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.7;
  animation: floatShape 20s infinite alternate ease-in-out;
}

.shape-1 {
  width: 450px; height: 450px;
  background: rgba(32, 168, 216, 0.3);
  top: -10%; left: -10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 350px; height: 350px;
  background: rgba(77, 189, 116, 0.2);
  bottom: -10%; right: -5%;
  animation-delay: -5s;
}

.shape-3 {
  width: 300px; height: 300px;
  background: rgba(99, 194, 222, 0.3);
  bottom: 20%; left: 10%;
  animation-delay: -10s;
}

.shape-4 {
  width: 400px; height: 400px;
  background: rgba(32, 168, 216, 0.2);
  top: 10%; right: 20%;
  animation-delay: -2s;
}

@keyframes floatShape {
  0% { transform: translate(0, 0) scale(1) rotate(0deg); }
  33% { transform: translate(40px, -50px) scale(1.1) rotate(120deg); }
  66% { transform: translate(-30px, 40px) scale(0.9) rotate(240deg); }
  100% { transform: translate(0, 0) scale(1) rotate(360deg); }
}

/* Logo Animation */
.login-logo {
  transition: transform 0.3s ease;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}
.login-logo:hover {
  transform: scale(1.05);
}

/* Custom Inputs */
.custom-input-group {
  display: flex;
  align-items: center;
  background-color: #f4f7f6;
  border-radius: 12px;
  padding: 8px 16px;
  border: 1px solid transparent;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.custom-input-group:focus-within {
  background-color: #ffffff;
  border-color: #20a8d8;
  box-shadow: 0 4px 12px rgba(32, 168, 216, 0.15);
  transform: translateY(-1px);
}

.input-icon {
  color: #a0aab5;
  font-size: 1.1rem;
  margin-right: 12px;
  display: flex;
  align-items: center;
}

.custom-input {
  border: none;
  background: transparent;
  width: 100%;
  color: #495057;
  padding: 8px 0;
  outline: none;
  font-weight: 500;
  box-shadow: none !important;
}

.custom-input::placeholder {
  color: #a0aab5;
  font-weight: 400;
}

.custom-input:focus {
  background: transparent;
}

/* Modern Button */
.btn-login {
  background: #20a8d8;
  border: none;
  border-radius: 12px;
  padding: 12px;
  font-weight: 500;
  font-size: 1rem;
  margin-top: 15px;
  transition: background-color 0.3s ease;
}

.btn-login:hover:not(:disabled) {
  background: #1985ac;
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Right Side Gradient */
.login-info-card {
  background: linear-gradient(135deg, #20a8d8 0%, #1a8a9d 100%); /* Blue gradient compliant with system theme */
  transition: background 0.3s ease, border-color 0.3s ease;
}

.login-info-card h2 {
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .login-card-group {
    flex-direction: column;
  }
}

/* ---------------------------------------------------
   DARK MODE SUPPORT FOR LOGIN
   --------------------------------------------------- */
.login-dark {
  background: linear-gradient(135deg, #1e1e2d 0%, #11111a 100%) !important;
}

.login-dark .shape-1 { background: rgba(59, 130, 246, 0.35); filter: blur(70px); }
.login-dark .shape-2 { background: rgba(16, 185, 129, 0.25); filter: blur(70px); }
.login-dark .shape-3 { background: rgba(14, 165, 233, 0.35); filter: blur(70px); }
.login-dark .shape-4 { background: rgba(99, 102, 241, 0.25); filter: blur(70px); }

.login-dark .login-form-card {
  background-color: rgba(30, 30, 45, 0.85) !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.login-dark .login-info-card .card-body {
  background-color: transparent !important;
}

.login-dark .text-dark {
  color: #f7fafc !important;
}

.login-dark .text-muted {
  color: #a0aec0 !important;
}

.login-dark .custom-input-group {
  background-color: #1a202c;
  border-color: #4a5568;
}

.login-dark .custom-input-group:focus-within {
  background-color: #2d3748;
  border-color: #63b3ed;
  box-shadow: 0 4px 12px rgba(99, 179, 237, 0.15);
}

.login-dark .custom-input {
  color: #f7fafc;
}

.login-dark .custom-input::placeholder {
  color: #718096;
}

.login-dark .input-icon {
  color: #718096;
}

.login-dark .login-info-card {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%) !important;
  border-left: 1px solid #4a5568;
}

/* ---------------------------------------------------
   COMMERCIAL DASHBOARD GRAPHICS (RIGHT SIDE)
   --------------------------------------------------- */
.login-graphics-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
}

.graphics-grid {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 30px 30px;
  opacity: 0.5;
}

.graphic-card {
  position: absolute;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  z-index: 0;
}

.card-1 {
  top: 8%; right: -5%;
  width: 150px; height: 130px;
  animation: floatCard 6s ease-in-out infinite;
}

.card-2 {
  bottom: 15%; left: -8%;
  width: 170px; height: 95px;
  animation: floatCard2 8s ease-in-out infinite;
}

.card-3 {
  top: 40%; left: -15%;
  width: 140px; height: 80px;
  animation: floatCard3 7s ease-in-out infinite;
}

.graphic-header {
  width: 40%; height: 6px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 3px; margin-bottom: 20px;
}

.graphic-bar-container {
  display: flex; align-items: flex-end; justify-content: space-between;
  height: 65px; padding: 0 5px;
}

.graphic-bar {
  width: 14px; background: rgba(255, 255, 255, 0.5);
  border-radius: 4px 4px 0 0;
}

.graphic-bar:nth-child(1) { height: 40%; animation: barGrow 2s ease-out forwards; }
.graphic-bar:nth-child(2) { height: 75%; animation: barGrow 2.5s ease-out forwards; }
.graphic-bar:nth-child(3) { height: 55%; animation: barGrow 3s ease-out forwards; }
.graphic-bar:nth-child(4) { height: 90%; background: #fff; animation: barGrow 3.5s ease-out forwards; box-shadow: 0 0 10px rgba(255,255,255,0.5); }

@keyframes barGrow {
  from { transform: scaleY(0); transform-origin: bottom; }
  to { transform: scaleY(1); transform-origin: bottom; }
}

.graphic-circle-wrap { display: flex; align-items: center; }

.graphic-circle {
  width: 40px; height: 40px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.2);
  border-top-color: #fff; border-right-color: #fff;
  margin-right: 15px;
  animation: spinCircle 10s linear infinite;
}

@keyframes spinCircle { 100% { transform: rotate(360deg); } }

.graphic-lines { flex: 1; }
.g-line {
  height: 6px; background: rgba(255, 255, 255, 0.3);
  border-radius: 3px; margin-bottom: 8px;
}
.g-line.w-75 { width: 75%; }
.g-line.w-50 { width: 50%; }

.mini-chart { width: 100%; height: 40px; margin-top: 5px; }

.graphic-trend {
  position: absolute; bottom: 0; left: 0;
  width: 100%; height: 40%;
  z-index: 0; opacity: 0.6;
}

.glass-content-box {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  z-index: 2; position: relative;
}

.z-index-1 { z-index: 1; }

@keyframes floatCard {
  0% { transform: translateY(0) rotate(-5deg); }
  50% { transform: translateY(-15px) rotate(-2deg); }
  100% { transform: translateY(0) rotate(-5deg); }
}

@keyframes floatCard2 {
  0% { transform: translateY(0) rotate(5deg); }
  50% { transform: translateY(-15px) rotate(8deg); }
  100% { transform: translateY(0) rotate(5deg); }
}

@keyframes floatCard3 {
  0% { transform: translateY(0) rotate(-8deg); }
  50% { transform: translateY(15px) rotate(-4deg); }
  100% { transform: translateY(0) rotate(-8deg); }
}

/* Dark mode adjustments for glass box */
.login-dark .glass-content-box {
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
</style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue